const STORAGE_PREFIX = "ee:lastContext:";

function normalizeAccountId(accountId) {
  return String(accountId || "").trim().toLowerCase();
}

function buildStorageKey(accountId) {
  const normalized = normalizeAccountId(accountId);
  return normalized ? `${STORAGE_PREFIX}${normalized}` : null;
}

export function getLastSelectedContextKey(accountId) {
  const key = buildStorageKey(accountId);
  if (!key || typeof localStorage === "undefined") return null;

  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

export function rememberLastSelectedContextKey(accountId, contextKey) {
  const key = buildStorageKey(accountId);
  if (!key || !contextKey || typeof localStorage === "undefined") return;

  try {
    localStorage.setItem(key, contextKey);
  } catch (error) {
    // Browser storage can be disabled; auth still works without this preference.
  }
}

export function clearLastSelectedContextKey(accountId) {
  const key = buildStorageKey(accountId);
  if (!key || typeof localStorage === "undefined") return;

  try {
    localStorage.removeItem(key);
  } catch (error) {
    // Browser storage can be disabled; clearing is best-effort.
  }
}
